import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('PassengerList', {
    error: (
        <FormattedMessage
            id='front-app/PassengerList/Notification/Error:title'
            defaultMessage='Passenger List Error'
        />
    ),
    warning: (
        <FormattedMessage
            id='front-app/PassengerList/Notification/Warning:title'
            defaultMessage='Passenger List Warning'
        />
    ),
    info: (
        <FormattedMessage
            id='front-app/PassengerList/Notification/Info:title'
            defaultMessage='Passenger List Info'
        />
    ),
    success: (
        <FormattedMessage
            id='front-app/PassengerList/Notification/Info:title'
            defaultMessage='Passenger List Info'
        />
    ),
});

export const passengerListNotifications = {
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
